///jacques-andre-editeur\proshop-v2\frontend\src\screens\admin\AuthorListScreen.jsx
import { Table, Button, Row, Col, Container } from 'react-bootstrap';
import { FaEdit, FaPlus, FaTrash, FaEye, FaEyeSlash, FaSort, FaList } from 'react-icons/fa';
import { Link, useParams, useNavigate } from 'react-router-dom';
import DOMPurify from 'dompurify';
import Message from '../../components/Message';
import Loader from '../../components/Loader';
import Paginate from '../../components/Paginate';
import {
  useGetAuthorsQuery,
  useDeleteAuthorMutation,
  useToggleAuthorVisibilityMutation,
  useToggleAuthorInListMutation,
} from '../../slices/authorsApiSlice';
import { toast } from 'react-toastify';
import { useState } from 'react';

const AuthorListScreen = () => {
  const { pageNumber } = useParams();

  const [deleteAuthor, { isLoading: loadingDelete }] = useDeleteAuthorMutation();
  const [toggleVisibility, { isLoading: loadingVisibility }] = useToggleAuthorVisibilityMutation();
  //const [toggleInList, { isLoading: loadingInList }] = useToggleAuthorInListMutation();
  const [toggleInList] = useToggleAuthorInListMutation();

  const [sortConfig, setSortConfig] = useState({
    key: '_id', // Tri initial par ObjectId
    direction: 'asc', // Ordre décroissant par défaut
  });

  const [searchTerm, setSearchTerm] = useState('');


  const navigate = useNavigate();

  const goToCreateAuthorPage = () => {
    navigate('/admin/authoradd');
  };

  const deleteHandler = async (id) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer cet auteur ?')) {
      try {
        await deleteAuthor(id);
        refetch();
      } catch (err) {
        toast.error(err?.data?.message || err.error);
      }
    }
  };

  const toggleVisibilityHandler = async (id) => {
    try {
      await toggleVisibility(id);
      refetch();
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };

  const toggleInListHandler = async (id) => {
    try {
      await toggleInList(id);
      refetch();
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };

  const { data, isLoading, error, refetch } = useGetAuthorsQuery({
    pageNumber,
    isAdminSpace: true,
    sortKey: sortConfig.key,
    sortDirection: sortConfig.direction,
    parPage:20,
    keyword: searchTerm,
  });

  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc',
    }));
    refetch();
  };

  return (
    <Container>
      <Row className="align-items-center">
        <Col>
          <h1 style={{ cursor: 'pointer' }} onClick={() => handleSort('_id')}>
            Tous les auteurs <FaSort />
          </h1>
        </Col>
          <Col md={4}>
            <input
              type="text"
              className="form-control"
              placeholder="Rechercher par prénom ou nom"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Col>


        <Col className="text-end">
          <Button className="my-3" onClick={goToCreateAuthorPage}>
            <FaPlus /> Ajouter un auteur
          </Button>
        </Col>
      </Row>

      {loadingDelete && <Loader />}
      {loadingVisibility && <Loader />}
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">{error.data.message}</Message>
      ) : (
        <>
          <Table striped bordered hover responsive className="table-sm">
            <thead>
              <tr>
                <th onClick={() => handleSort('firstName')} style={{ cursor: 'pointer' }}>
                  Prénom <FaSort />
                </th>
                <th onClick={() => handleSort('lastName')} style={{ cursor: 'pointer' }}>
                  Nom ou pseudo <FaSort />
                </th>
                <th>Bio</th>
                <th onClick={() => handleSort('isVisible')} style={{ cursor: 'pointer' }}>
                  Actions <FaEye style={{ color: 'grey' }} />
                </th>
              </tr>
            </thead>
            <tbody>
              {data?.authors.map((author) => (
                <tr key={author._id}>
                  <td>
                    <Link
                      to={`/admin/author/${author._id}/edit`}
                      style={{ textDecoration: 'none', color: 'inherit' }}
                      title="Modifier la fiche"
                    >
                      {author.firstName}
                    </Link>
                  </td>
                  <td>
                    <Link
                      to={`/admin/author/${author._id}/edit`}
                      style={{ textDecoration: 'none', color: 'inherit' }}
                      title="Modifier la fiche"
                    >
                      {author.lastName}
                    </Link>
                  </td>
                  <td>{author.bio ? <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(author.bio.slice(0, 50) + '...').replace(/<[^>]+>/g, '') }} /> : 'Non spécifié'}
                </td>

                  <td>
                    <Button
                      as={Link}
                      to={`/admin/author/${author._id}/edit`}
                      variant="light"
                      className="btn-sm mx-2"
                      title="Modifier la fiche"
                    >
                      <FaEdit />
                    </Button>
                    <Button
                      variant="light"
                      className="btn-sm"
                      onClick={() => toggleVisibilityHandler(author._id)}
                      title={author.isVisible ? 'Cacher la fiche' : 'Rendre la fiche visible'}
                    >
                      {author.isVisible ? (
                        <>
                          <FaEye style={{ color: 'turquoise' }} />
                          <FaEyeSlash style={{ color: 'grey' }} />
                        </>
                      ) : (
                        <>
                          <FaEye style={{ color: 'grey' }} />
                          <FaEyeSlash style={{ color: 'red' }} />
                        </>
                      )}
                    </Button>
                    <Button
                      variant="light"
                      className="btn-sm"
                      onClick={() => deleteHandler(author._id)}
                      title={
                        author.isVisible
                          ? 'Seules les fiches non visibles peuvent être supprimées'
                          : 'Supprimer la fiche'
                      }
                      disabled={author.isVisible}
                    >
                      <FaTrash style={author.isVisible ? { color: 'grey' } : { color: 'red' }} />
                    </Button>
                    <Button
                      variant="light"
                      className="btn-sm"
                      onClick={() => toggleInListHandler(author._id)}
                      title={author.inList ? 'Cacher  l\'auteur dans la liste' : 'Afficher l\'auteur dans la liste'}
                    >
                      {author.inList ? (
                          <FaList style={{ color: 'turquoise' }} />
                      ) : (
                          <FaList style={{ color: 'red' }} />
                      )}
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <Paginate pages={data.pages} page={data.page} isAdmin={true} basePath="/admin/authorlist" />
        </>
      )}
    </Container>
  );
};

export default AuthorListScreen;
